module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagef"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/p15.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("GRAMMAR GREMLIN")]), _vm._v(" "), _c('p', {
    staticClass: "center-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("This book has been professionally edited and proofread. However, sometimes typos can slip through the cracks. Please note that I take these very seriously, so if you find any errors, email the Grammar Factory team at "), _c('a', {
    attrs: {
      "href": "mailto:info@grammarfactory.com"
    }
  }, [_vm._v("info@grammarfactory.com")]), _vm._v(" and we’ll send you a free Grammar Gremlin as a thank you.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4145ca30","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm03.vue
// module id = 78
// module chunks = 0